import { Injectable } from '@angular/core';
import { of, Observable } from 'rxjs';
import { LocalePersistencePort } from '@app/common/locale/application/ports/locale-persistence.port';
import { Locale } from '@app/common/locale/domain/entities/locale';
import { LoadUserLocaleUseCase } from '@app/common/locale/application/use-cases/load-user-locale.use-case';
import { UpdateUserLocaleUseCase } from '@app/common/locale/application/use-cases/update-user-locale.use-case';

@Injectable({
    providedIn: 'root',
})
export class BackendLocalePersistence implements LocalePersistencePort {
    public constructor(
        private loadUserLocaleUseCase: LoadUserLocaleUseCase,
        private updateUserLocaleUseCase: UpdateUserLocaleUseCase,
    ) {}

    public save(locale: Locale, userId?: string): Observable<void> {
        if (!userId) {
            return of(undefined);
        }

        return this.updateUserLocaleUseCase.execute(userId, locale);
    }

    public load(userId?: string): Observable<Locale | null> {
        if (!userId) {
            return of(null);
        }

        return this.loadUserLocaleUseCase.execute(userId);
    }

    public clear(): Observable<void> {
        return of(undefined);
    }
}
